import { NodeType, type ReferenceTag } from '../types';
import { nodeTone, type NodeTone } from '../components/nodes/nodeTheme';

export interface ReferenceTagInfo {
  id: ReferenceTag;
  label: string;
  plural: string;
  /**
   * The colour of the kind the tag names, so a word has one colour across the app: a
   * "Character" tag is the Character node's colour, whatever that is. A tag is shown as a soft
   * chip (the tone's tint with its deep text), never as a full-strength fill:
   * `<span className="ns-chip ns-chip-sm ns-chip-tone" data-tone={info.tone}>`.
   */
  tone: NodeTone;
}

export const REFERENCE_TAGS: ReferenceTagInfo[] = [
  { id: 'character', label: 'Character', plural: 'Characters', tone: nodeTone(NodeType.CHARACTER_NODE) },
  { id: 'prop', label: 'Prop', plural: 'Props', tone: nodeTone(NodeType.PROP_NODE) },
  // A background is a place: the Location node's colour
  { id: 'background', label: 'Background', plural: 'Backgrounds', tone: nodeTone(NodeType.LOCATION_NODE) },
  // No kind of node is a style; orchid is a tone no other tag has
  { id: 'style', label: 'Style', plural: 'Styles', tone: 'orchid' },
  { id: 'other', label: 'Other', plural: 'Other', tone: 'ink' },
];

export const referenceTagInfo = (tag?: ReferenceTag | null): ReferenceTagInfo | undefined =>
  REFERENCE_TAGS.find(info => info.id === tag);

export const isReferenceTag = (value: string): value is ReferenceTag => REFERENCE_TAGS.some(info => info.id === value);
